import { Editor } from 'tinymce'

const markerTypes = {
    'mds-plus-marker': { label: 'Plus', icon: 'plus-marker' },
} as const;
const markerTypeKeys = Object.keys(markerTypes) as (keyof typeof markerTypes)[];


/**
 * Accordion Box Plugin
 */
export const registerAccordionBox = (editor: Editor) => {
    
    editor.ui.registry.addToggleButton('toggle-box-format', {
        icon: 'box',
        tooltip: 'Toggle Box Format',
        onSetup(api) {
            const node = editor.selection.getNode().closest('details, div');

            const active = node?.classList.contains('mds-box-format');
            api.setIcon(active ? 'rectangle-cross' : 'rectangle');
            
            return () => undefined
        },
        onAction: (api) => {
          const node = editor.selection.getNode().closest('details, div');
          if (!node) return;

          node.classList.toggle('mds-box-format');
          const active = node.classList.contains('mds-box-format');
          api.setIcon(active ? 'rectangle-cross' : 'rectangle');
          editor.dispatch('Change')
        },
    })

    editor.ui.registry.addMenuButton('accordion-marker', {
		icon: 'caret-marker',
		tooltip: 'Accordion Icon',
		onSetup: (api) => {
			const node = editor.selection.getNode()?.closest('details');
			if (!node) return () => undefined;

			Object.entries(markerTypes).forEach(([key, entry]) => {
				if (node.classList.contains(key)) {
					api.setIcon(entry.icon);
				}
			})

			return () => undefined;
		},
		fetch: (cb, ctx, api) => {
			const node = editor.selection.getNode()?.closest('details');
			if (!node) return;

			const setTypeClass = (type?: keyof typeof markerTypes) => {
				const addClass = type ? !node.classList.contains(type) : false;
				node.classList.remove(...markerTypeKeys);
				if (addClass && type) node.classList.add(type);
				editor.dispatch('Change')
			};
			cb([
				{ 
					type: 'togglemenuitem', 
					value: 'normal', 
					text: 'Normal',
					icon: 'caret-marker',
					onAction: () => setTypeClass(), 
					active: !node.className.match(new RegExp(`(${markerTypeKeys.join('|')})`))
				},
				...Object.entries(markerTypes).map(([key, entry]) => ({
					type: 'togglemenuitem' as const,
					value: 'box-format-' + key,
					text: entry.label,
					icon: entry.icon,
					onAction: () => setTypeClass(key as keyof typeof markerTypes),
					active: node.classList.contains(key)
				}))
			]);
		}
	})

    editor.ui.registry.addContextToolbar("accordion-extra2", {
        predicate: t => editor.dom.is(t, "details") && editor.getBody().contains(t) && editor.dom.isEditable(t.parentNode),
        items: "accordion-marker",
        scope: "node",
        position: "node"
    })


    // Adjust Accordion Context Toolbar
    editor.ui.registry.addContextToolbar("accordion-extra", {
        predicate: t => t.classList.contains('mds-box-format') || (editor.dom.is(t, "details") && editor.getBody().contains(t) && editor.dom.isEditable(t.parentNode)),
        items: "toggle-box-format",
        scope: "node",
        position: "node"
    })
}